module.exports = __webpack_public_path__ + "media/images/front/sp/article/doctor01-e9f75cd00d3903049da0f8dcb910bdcc.png";